<template>
  <div id="formPerson">
    <RoleSelecter
      v-if="role_selector"
      @addRole="addNewRole"
      @cancelNewRole="cancelNewRole"
    ></RoleSelecter>
    <Topbar @action="fnAction"></Topbar>
    <ClipperImage
      v-if="clipper"
      :image="clipper"
      @getImage="showThumb"
    ></ClipperImage>
    <v-container class="center">
      <v-layout row wrap class="section-container" id="basic">
        <v-flex xs12 class="item">
          <v-form ref="form" v-model="valid">
            <v-container>
              <v-layout row wrap>
                <v-flex @click="show_basic = !show_basic" xs12 class="name">{{
                  $t("basic_info")
                }}</v-flex>
                <div
                  v-show="show_basic"
                  style="width:100%;height:auto;display:contents;"
                >
                  <!-- <v-flex xs12 class="clear"><div class="clear" style="height: 25px"></div></v-flex>
                        <v-flex xs12 md12 class="item">
                            <div class="image">
                                <img @click="addThumbnail('avatar')" v-if="person['avatar']" :src="person['avatar' + '_preview' ]" />
                                <div @click="addThumbnail('avatar')" v-else class="addthumb">
                                <div><v-icon x-large >add</v-icon></div>
                                <div class="text">{{ $t( 'add' ) + " " + $t( 'avatar' ) }}</div>
                                </div>
                                <input
                                type="file"
                                style="display: none"
                                ref="avatar"
                                accept="image/*"
                                @change="onThumbnailPicked"
                                >
                            </div>
                        </v-flex> -->
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.name' | i18n"
                      :value="person['name'] | checkParam"
                      @change="v => (person['name'] = v)"
                      outline
                      :rules="[value => !!value || $t('rules.required')]"
                      class="upper"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.surname' | i18n"
                      :value="person['surname'] | checkParam"
                      @change="v => (person['surname'] = v)"
                      outline
                      :rules="[]"
                      class="upper"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 class="item">
                    <v-radio-group v-model="person['gender']" row>
                      <v-radio
                        v-for="(gender, k) in getOptions(
                          'persons/getGenders',
                          false
                        )"
                        :label="gender.text | i18n"
                        :value="gender.value"
                        :key="k"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs4 md8 class="item">
                    <v-text-field
                      :label="'params.email' | i18n"
                      :value="person['email'] | checkParam"
                      @change="v => (person['email'] = v)"
                      outline
                      :rules="[]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 class="item">
                    <v-text-field
                      :label="'params.phone' | i18n"
                      :value="person['phone'] | checkParam"
                      @change="v => (person['phone'] = v)"
                      outline
                      :rules="[]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 class="item">
                    <v-text-field
                      :label="'params.mobile' | i18n"
                      :value="person['phone2'] | checkParam"
                      @change="v => (person['phone2'] = v)"
                      outline
                      :rules="[]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 class="item"> </v-flex>
                  <!-- DNI/NIE/PASSPORT -->
                  <v-flex xs6 md4 class="item">
                    <v-radio-group v-model="person['document_type']" row>
                      <v-radio :label="$t('params.dni')" value="1"></v-radio>
                      <v-radio :label="$t('params.nie')" value="2"></v-radio>
                      <v-radio
                        :label="$t('params.passport')"
                        value="3"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs6 md8 class="item">
                    <v-text-field
                      :label="'params.dni' | i18n"
                      :value="person['dni'] | checkParam"
                      @change="v => (person['dni'] = v)"
                      outline
                      :error-messages="errors_dni"
                      class="upper"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md3 class="item">
                    <v-select
                      v-model="person['lang']"
                      :multiple="false"
                      :items="languages"
                      :label="'params.language' | i18n"
                      :disabled="false"
                    ></v-select>
                  </v-flex>
                  <v-flex xs6 md3 class="item">
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      full-width
                      max-width="290"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :label="$t('params.birthday')"
                          v-model="person.birthday"
                          clearable
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="person.birthday"
                        @change="menu = false"
                        :first-day-of-week="1"
                        locale="ca"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <!-- <v-flex xs6 md4 class="item">
                        </v-flex> -->
                  <v-flex xs6 md3 class="item">
                    <v-switch
                      v-model="person['status']"
                      :label="'params.active' | i18n"
                    ></v-switch>
                  </v-flex>
                </div>

                <v-flex xs12 class="clear"
                  ><div class="clear" style="height: 25px"></div
                ></v-flex>
                <v-flex xs12 class="name">{{ $t("other_info") }}</v-flex>

                <div style="width:100%;height:auto;display:contents;">
                  <v-flex xs6 md4 class="item">
                    <v-text-field
                      :label="'params.address' | i18n"
                      :value="person['address'] | checkParam"
                      @change="v => (person['address'] = v)"
                      outline
                      :rules="[]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 class="item">
                    <v-text-field
                      :label="'params.city' | i18n"
                      :value="person['city'] | checkParam"
                      @change="v => (person['city'] = v)"
                      outline
                      :rules="[]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 class="item">
                    <v-text-field
                      :label="'params.cp' | i18n"
                      :value="person['cp'] | checkParam"
                      @change="v => (person['cp'] = v)"
                      outline
                      :rules="[]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 class="item">
                    <v-text-field
                      :label="'params.state' | i18n"
                      :value="person['state'] | checkParam"
                      @change="v => (person['state'] = v)"
                      outline
                      :rules="[]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 class="item">
                    <!-- <v-select v-if="item.type == 'autocomplete' && item.param != 'country_id' && item.param != 'nacionality'" v-model="data[ item.param ]" :label="item.label | i18n" :items="cAutoComplete[ item.param ]" @input.native="loadAutocomplete( $event, item )" autocomplete :disabled="false"></v-select> -->
                    <v-select
                      v-model="person['country_id']"
                      :label="'params.country' | i18n"
                      :items="countries"
                      @input.native="loadAutocomplete($event, false)"
                      autocomplete
                      :disabled="false"
                    ></v-select>
                  </v-flex>
                  <v-flex xs6 md4 class="item">
                    <!-- <v-select v-if="item.type == 'autocomplete' && item.param != 'country_id' && item.param != 'nacionality'" v-model="data[ item.param ]" :label="item.label | i18n" :items="cAutoComplete[ item.param ]" @input.native="loadAutocomplete( $event, item )" autocomplete :disabled="false"></v-select> -->
                    <v-select
                      v-model="person['nacionality']"
                      :label="'params.nacionality' | i18n"
                      :items="countries"
                      @input.native="loadAutocomplete($event, false)"
                      autocomplete
                      :disabled="false"
                    ></v-select>
                  </v-flex>
                  <v-flex xs6 md2 class="item">
                    <v-switch
                      v-model="person['b_alergy']"
                      :label="'params.has_alergy' | i18n"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs6 md5 class="item">
                    <v-select
                      v-show="person['b_alergy']"
                      v-model="person['alergy']"
                      :multiple="true"
                      :items="getOptions('persons/getAlergies', false)"
                      :label="'params.alergy' | i18n"
                      :disabled="false"
                    ></v-select>
                  </v-flex>
                  <v-flex xs6 md5 class="item">
                    <v-text-field
                      v-show="person['b_alergy']"
                      v-model="person['other_allergies']"
                      :label="'params.other_alergy' | i18n"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md4 class="item">
                    <v-switch
                      v-model="person['b_news']"
                      :label="'params.accept_news' | i18n"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs6 md4 class="item"> </v-flex>
                  <v-flex xs6 md4 class="item"> </v-flex>
                </div>

                <v-flex xs12 class="clear" v-show="!is_new"
                  ><div class="clear" style="height: 25px"></div
                ></v-flex>
                <v-flex xs12 class="name" v-show="!is_new"
                  >{{ $t("roles.actives") }}
                  <div @click="addRole" class="add">
                    {{ "roles.create" | i18n }}
                  </div></v-flex
                >
                <v-flex xs12 class="clear" v-show="!is_new"
                  ><div class="clear" style="height: 25px"></div
                ></v-flex>

                <RoleList
                  v-show="!is_new"
                  :roles="person.current_roles"
                  @remove="fnRoleRemove"
                  :remove="true"
                ></RoleList>

                <v-flex
                  v-if="newRoles && Object.keys(newRoles).length > 0"
                  xs12
                  class="clear"
                  ><div class="clear" style="height: 25px"></div
                ></v-flex>
                <v-flex
                  v-if="newRoles && Object.keys(newRoles).length > 0"
                  xs12
                  class="name new_roles"
                  >{{ $t("roles.new") }}</v-flex
                >
                <v-flex
                  v-if="newRoles && Object.keys(newRoles).length > 0"
                  xs12
                  class="clear"
                  ><div class="clear" style="height: 25px"></div
                ></v-flex>
                <RoleList
                  :roles="newRoles"
                  @remove="fnRoleRemove"
                  :remove="true"
                ></RoleList>

                <v-flex
                  v-if="deleteRoles && Object.keys(deleteRoles).length > 0"
                  xs12
                  class="clear"
                  ><div class="clear" style="height: 25px"></div
                ></v-flex>
                <v-flex
                  v-if="deleteRoles && Object.keys(deleteRoles).length > 0"
                  xs12
                  class="name"
                  >{{ $t("roles.deleted") }}</v-flex
                >
                <v-flex
                  v-if="deleteRoles && Object.keys(deleteRoles).length > 0"
                  xs12
                  class="clear"
                  ><div class="clear" style="height: 25px"></div
                ></v-flex>
                <RoleList :roles="deleteRoles" :remove="false"></RoleList>

                <!-- <v-flex xs12 md6 class="item">
                        <v-textarea outlined :label="'' | i18n" :value="person[ '' ] | checkParam" @change="v => data[ '' ] = v" outline :rules="[]" :disabled="false"></v-textarea>
                    </v-flex> -->
              </v-layout>
            </v-container>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import i18n from "@/i18n";

import Table from "@/components/ui/Table";
import Topbar from "@/components/ui/Topbar";
import ClipperImage from "@/components/ui/ClipperImage";
import RoleList from "@/components/ui/RoleList";
import RoleSelecter from "@/components/ui/RoleSelecter";

export default {
  name: "PersonForm",
  components: { Table, Topbar, ClipperImage, RoleList, RoleSelecter },
  props: { page: String, action: String },
  data() {
    return {
      person: { document_type: "1", status: 1 },
      menu: false,
      modal: false,
      valid: true,
      data_loaded: false,
      clipper: false,
      param_select: null,
      autocompletes: {},
      param_autocomplete: false,
      toAutoComplete: null,
      role_selector: false,
      new_roles: [],
      delete_roles: [],
      club_id: false,
      team_id: false,
      show_basic: true,
      show_other: false,
      errors_dni: [],
      is_new: false
    };
  },
  computed: {
    countries() {
      var oCountries = this.$store.getters.getCountries();
      var aResult = [];
      for (var k in oCountries) {
        aResult.push({ text: oCountries[k].name, value: oCountries[k].id });
      }

      return aResult;
    },

    documents_type() {
      var oDocuments = this.$store.getters.getDocumentsPersonType();
      var aResult = [];
      for (var k in oDocuments) {
        aResult.push({
          text: i18n.t(oDocuments[k].name),
          value: oDocuments[k].id
        });
      }

      return aResult;
    },

    document_type_rules() {
      return [
        v => this.validateDocument(v) || "El document es incorrecte",
        v =>
          this.notDuplicateDocument(v) ||
          "Ja existeix una persona amb aquest document"
      ];
    },

    events_active() {
      var aEvents = this.$store.getters["events/getActives"]();
      var aResult = [];
      var self = this;
      aEvents.forEach(event => {
        aResult.push({
          value: event.id,
          text: self.$root.formatEventName(event.name, event.edition)
        });
      });
      return aResult;
    },

    params() {
      var fullPage = this.page.replace("event_", "");
      var params =
        fullPage !== "persons_role_edit"
          ? { ...this.$store.getters["navigation/getCurrentPage"].params }
          : {
              ...this.$store.getters["navigation/getCurrentPage"].types[
                this.$route.params.type
              ].params
            };
      var aParams = [];
      for (var k in params) {
        var pr = params[k];
        if (
          typeof pr.only_event === "undefined" ||
          !pr.only_event ||
          (pr.only_event && this.$store.getters.isEventSelected)
        ) {
          aParams.push(pr);
        }
      }
      // console.log( params );
      return aParams;
    },

    cAutoComplete: {
      get() {
        return this.autocompletes;
      },
      set(value) {
        if (this.param_autocomplete) {
          var oAux = { ...this.autocompletes };
          oAux[this.param_autocomplete] = value;
          this.autocompletes = oAux;
        }
      }
    },

    newRoles: {
      get() {
        return ObjectToArray(this.new_roles);
      },
      set(value) {
        this.new_roles = value;
      }
    },

    deleteRoles: {
      get() {
        return ObjectToArray(this.delete_roles);
      },
      set(value) {
        this.delete_roles = value;
      }
    },

    languages() {
      var langs = ObjectToArray(this.$store.getters.getLanguages);
      var aLangs = [];
      langs.forEach(lang => {
        aLangs.push({ text: lang.fullname, value: lang.id });
      });
      return aLangs;
    }
  },
  watch: {
    // call again the method if the route changes
    $route: "loadDataPage"
  },
  created() {
    var self = this;
    var event = this.$store.getters.isEventSelected
      ? this.$store.getters["events/getCurrentEvent"]().id
      : undefined;

    if (this.$route.name.match(/persons_add/)) {
      this.is_new = true;
    }

    this.$store.dispatch("clubs/loadList", { event: event }).then(function() {
      self.$store.dispatch("teams/loadList", { event: event, page_options: { num_page: -1, num_items: -1 }, filters: {status: 6} }).then(function() {
        if (self.$route.params.action == "new_role") {
          var team_id, club_id, category_id;

          var contact_type = 1;
          switch (self.$route.params.type) {
            case "player":
              contact_type = 107;
              break;
            case "staff":
              contact_type = 1;
              break;
            case "contact":
              contact_type = self.$route.params.entity == "club" ? 6 : 110;
              break;
          }

          if (self.$route.params.entity == "club") {
            club_id = self.$route.params.entity_id;
          } else if (self.$route.params.entity == "team") {
            team_id = self.$route.params.entity_id;

            var team = self.$store.getters["teams/get_by_id"](team_id);
            club_id = team.club.id;
            category_id = team.category.id;
          }

          var roles = [...self.newRoles];
          var id = moment().valueOf();
          roles.push({
            id: id,
            contact_type_id: contact_type,
            event_id: self.$store.getters.isEventSelected
              ? self.$store.getters["events/getCurrentEvent"]().id
              : null,
            club_id: club_id,
            team_id: team_id,
            category_id: category_id
          });
          self.newRoles = roles;
        }

        self.loadDataPage();
        if (self.$route.params.action == "new_role") {
          setTimeout(function() {
            document
              .querySelector("#formPerson")
              .scroll(0, document.querySelector(".new_roles").offsetTop);
          }, 1000);
        }
      });
    });
  },
  methods: {
    loadDataPage() {
      this.$store.commit("setTopbarActionsVisible", true);
      this.$store.commit("setMenuVisible", true);

      var id = this.$route.params.id;
      var self = this;
      if (id !== undefined) {
        this.$overlay.loading();

        this.$store.dispatch("persons/load_by_id", { id: id }).then(function() {
          self.person = { ...self.$store.getters["persons/get_by_id"](id) };

          self.person.gender =
            self.person.gender == "male"
              ? 1
              : self.person.gender == "female"
              ? 2
              : 3;
          self.person.birthday =
            self.person.birthday != null &&
            moment(self.person.birthday).isValid()
              ? moment(self.person.birthday).format("YYYY-MM-DD")
              : null;

          // var aRoles = self.person.current_roles
          // var aCurrentRoles = []
          // aRoles.forEach( role => {
          //     if( [1,2,107,110,111].includes( parseInt( role.contact_type_id ) ) ){
          //         role.club_id = role.team.club.id
          //         role.team_id = role.team.id
          //         role.event_id = role.event.id
          //         role.category_id = role.team.category.id
          //     }
          //     else {
          //         role.club_id = role.club.id
          //     }
          // })

          // self.person.current_roles = aRoles

          self.$overlay.hide();
        });
      } else {
        this.$overlay.hide();
      }
    },

    getOptions(options, filter, bFirstEmpty) {
      var bFirstEmpty =
        typeof bFirstEmpty === "undefined" ? false : bFirstEmpty;
      if (typeof options === "string") {
        var aOptions = [];
        // console.log( options );
        // console.log( filter );
        if (typeof filter.params !== "undefined") {
          var values = this.$store.getters[options](filter.params);
        } else {
          var values = this.$store.getters[options]();
        }
        if (bFirstEmpty)
          aOptions.push({ value: -1, text: i18n.t(filter.label) });
        for (var i in values) {
          var value = values[i];
          name =
            typeof filter.translate === "undefined" || filter.translate
              ? i18n.t(value.name)
              : value.name;
          aOptions.push({ value: value.id, text: name });
        }

        return aOptions;
      } else {
        return options;
      }
    },

    loadAutocomplete(event, param) {
      this.param_autocomplete = param.param;
      clearTimeout(this.toAutoComplete);
      var self = this;
      this.toAutoComplete = setTimeout(function() {
        if (event.target.value.length > 2) {
          self.$store
            .dispatch(param.action, event.target.value)
            .then(function() {
              var aResults = self.$store.getters[param.getter]();
              var aResult = [];
              for (var k in aResults) {
                var result = aResults[k];
                aResult.push({ text: result.name, value: result.id });
              }

              self.cAutoComplete = aResult;
            });
        }
      }, 200);
    },

    addThumbnail(param) {
      this.param_select = param;
      this.$refs[param].click();
    },
    onThumbnailPicked(e) {
      const files = e.target.files;
      var self = this;
      if (files[0] !== undefined) {
        if (this.clipper) URL.revokeObjectURL(this.clipper);
        this.clipper = window.URL.createObjectURL(e.target.files[0]);
      }
    },
    showThumb(image) {
      // console.log( image );
      this.clipper = false;
      this.$refs[this.param_select].value = null;
      this.person[this.param_select + "_preview"] = image;

      function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      }

      if (image) {
        this.person[this.param_select] = dataURLtoFile(
          image,
          this.param_select + "_" + moment().valueOf() + ".jpg"
        );
      }
    },

    addRole() {
      this.role_selector = true;
    },

    fnRoleRemove(id) {
      var bFound = false;

      var roles = [...this.new_roles];
      var d_roles = { ...this.delete_roles };
      // d_roles[ id ] = { ...roles[ id ] }
      var pos = 0;
      roles.forEach(role => {
        if (role.id == id) {
          bFound = true;
          // d_roles[ id ] = { ...role }
          roles.splice(pos, 1);
        }
        pos++;
      });

      if (bFound) {
        this.newRoles = roles;
        this.deleteRoles = d_roles;
      } else {
        var roles = [...this.person.current_roles];
        var d_roles = { ...this.delete_roles };
        pos = 0;
        roles.forEach(role => {
          if (role.id == id) {
            bFound = true;
            d_roles[id] = { ...role };
            roles.splice(pos, 1);
          }
          pos++;
        });
        this.person.current_roles = roles;
        this.deleteRoles = d_roles;
      }
    },

    addNewRole(params) {
      var previousPage = this.$store.getters["navigation/getPreviousPage"];
      this.role_selector = false;

      var club_id,
        team_id,
        category_id,
        hotel_id = null;

      if (previousPage) {
        var name = previousPage.name.replace("event_", "").split("_")[0];
        if (name == "clubs") {
          club_id = previousPage.params.id;
        } else if (name == "teams") {
          team_id = previousPage.params.id;

          var team = this.$store.getters["teams/get_by_id"](team_id);
          club_id = team.club.id;
          category_id = team.category.id;
        } else if (name == "hotels") {
          hotel_id = previousPage.params.id;
        }
      }

      var roles = [...this.newRoles];
      var id = moment().valueOf();
      // roles[ id ] = { id: id, contact_type_id: params.contact_type, event_id: ( this.$store.getters.isEventSelected ? this.$store.getters[ 'events/getCurrentEvent' ]().id : null ), club_id: club_id, team_id: team_id, category_id: category_id }
      roles.push({
        id: id,
        contact_type_id: params.contact_type,
        event_id: this.$store.getters.isEventSelected
          ? this.$store.getters["events/getCurrentEvent"]().id
          : null,
        club_id: club_id,
        team_id: team_id,
        category_id: category_id,
        hotel_id: hotel_id
      });

      this.newRoles = roles;
      setTimeout(function() {
        document
          .querySelector("#formPerson")
          .scroll(0, document.querySelector(".new_roles").offsetTop);
      }, 200);
    },

    cancelNewRole() {
      this.role_selector = false;
    },

    fnAction(emit) {
      if (typeof emit.action === "undefined" || emit.action == null) return;
      switch (emit.action) {
        case "save":
          this.fnSave(emit.params);
          break;
        case "add_role":
          this.addRole();
          break;
      }
    },

    fnSave() {
      if (this.$refs.form.validate()) {
        var self = this;
        var page = this.page.replace("event_", "").split("_")[0];
        var fullPage = this.page.replace("event_", "");
        // console.log( page );
        var event = self.$store.getters.isEventSelected
          ? self.$store.getters["events/getCurrentEvent"]()
          : false;

        // this.person.new_roles = JSON.stringify( this.newRoles )
        // this.person.delete_roles = JSON.stringify( this.deleteRoles )

        var person = { ...this.person };
        if (person.alergy == "null") person.alergy = "";

        if (
          person.alergy &&
          person.alergy != null &&
          person.alergy.substring(0, 1) == ","
        )
          person.allergy.subtring(1);
        // person.current_roles = JSON.stringify( this.person.current_roles )

        this.$overlay.loading();

        this.$store
          .dispatch("persons/upload", {
            data: person,
            params: this.params,
            event: event
          })
          .then(function(idEntity) {
            // page = ( event )? 'event_' + page : page;
            // console.log( { name: page + '_card', params: { id: idEntity, event: ( (event )? self.$root.formatEventUrl( event.name, event.edition ).replace( '/event/', '' ) : null ) } } );
            // self.$router.push( { name: page + '_card', params: { id: idEntity, event: ( (event )? self.$root.formatEventUrl( event.name, event.edition ).replace( '/event/', '' ) : null ) } } );
            self.$store.dispatch("navigation/backPage", "/").then(function() {
              // self.$emit( "destroy" )
            });
          });
      } else {
        this.$popup.alert({
          message: i18n.t("exists_error_on_form"),
          btnSuccess: i18n.t("accept")
        });
      }
    },

    validateDocument(v) {
      if (
        this.person.document_type === "undefined" ||
        this.person.document_type == null ||
        v == null ||
        v == undefined
      )
        return true;

      if (this.person.document_type == 1) {
        // validate DNI
        // get letter from dni
        var expresion_regular_dni = /^\d{8}[a-zA-Z]$/;
        if (expresion_regular_dni.test(v) == true) {
          var numero = v.substr(0, v.length - 1);
          var letr = v.substr(v.length - 1, 1);
          numero = numero % 23;
          var letra = "TRWAGMYFPDXBNJZSQVHLCKET";
          letra = letra.substring(numero, numero + 1);

          return letra == letr.toUpperCase() ? true : false;
        } else {
          return false;
        }
      } else if (this.person.document_type == 2) {
        // validate NIE
        var nie_prefix = v.charAt(0);

        switch (nie_prefix) {
          case "X":
            nie_prefix = 0;
            break;
          case "Y":
            nie_prefix = 1;
            break;
          case "Z":
            nie_prefix = 2;
            break;
        }

        v = nie_prefix + v.substr(1);

        var expresion_regular_dni = /^\d{8}[a-zA-Z]$/;

        if (expresion_regular_dni.test(v) == true) {
          var numero = v.substr(0, v.length - 1);
          var letr = v.substr(v.length - 1, 1);
          numero = numero % 23;
          var letra = "TRWAGMYFPDXBNJZSQVHLCKET";
          letra = letra.substring(numero, numero + 1);

          return letra == letr.toUpperCase() ? true : false;
        } else {
          return false;
        }
      }

      return true;
    }
  },
  filters: {
    checkParam(value) {
      return value != null ? value : "";
    }
  },
  watch: {
    "person.dni": {
      handler(v, oldV) {
        this.errors_dni = [];
        if (
          this.person.document_type === "undefined" ||
          this.person.document_type == null
        ) {
        } else {
          if (!this.validateDocument(v))
            this.errors_dni = i18n.t("rules.dni_format_incorrect");
          else {
            this.$store
              .dispatch("persons/existsDNI", {
                person_id: this.person.id,
                dni: v
              })
              .then(exists => {
                if (exists) this.errors_dni = i18n.t("rules.dni_exists");
              });
          }
        }
      },
      deep: true
    },
    "person.document_type": {
      handler(v, oldV) {
        this.errors_dni = [];
        if (
          this.person.document_type === "undefined" ||
          this.person.document_type == null
        ) {
        } else {
          if (!this.validateDocument(this.person.dni))
            this.errors_dni = i18n.t("rules.dni_format_incorrect");
          else {
            this.$store
              .dispatch("persons/existsDNI", {
                person_id: this.person.id,
                dni: this.person.dni
              })
              .then(exists => {
                if (exists) this.errors_dni = i18n.t("rules.dni_exists");
              });
          }
        }
      },
      deep: true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#formPerson {
  width: 100%;
  display: inline-block;
  height: 100%;
  overflow-y: auto;

  .container {
    width: 80%;
    width: calc(100% - 350px);
    padding: 0px;

    &.center {
      margin: 0 auto;
    }

    .name {
      font-size: 22px;
      border-bottom: 2px solid;
      cursor: pointer;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      &::after {
        content: "";
        width: 20px;
        height: 20px;
        background: url(/img/down.svg);
        background-repeat: no-repeat;
        background-size: 20px;
        background-position: center right;
        position: absolute;
        transition-duration: 0.2s;
        margin-left: 10px;
      }

      &.hidden {
        &::after {
          transform: rotate(180deg);
          transition-duration: 0.2s;
        }
      }
    }

    .clear {
    }

    .role {
      padding: 0;

      .container {
        margin: 0;
        width: 100%;

        .name {
          font-size: 18px;
          color: #685f5f;
        }
      }
    }

    .section-container {
      padding: 20px;

      &#basic {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      }
      &#notes {
        background-color: $complem-color-light;
      }
      &#teams {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: -3px, $b: 8px, $s: 0px, $c: #00000011);
      }

      .item.flex {
        padding: 0 20px;

        .image {
          // width: 40%;
          float: left;
          padding: 0 40px;

          img,
          .addthumb {
            width: 150px;
            border: 1px solid #ccc;
            height: 150px;
            position: relative;
            cursor: pointer;
          }

          .addthumb div {
            width: 100%;
            display: block;
            top: 35%;
            position: absolute;
            text-align: center;
          }
          .addthumb .text {
            top: 60%;
          }
        }

        .name {
          position: relative;

          .remove {
            width: fit-content;
            float: right;
          }

          .add {
            background-image: url(/img/add_b.svg);
            background-size: 15px;
            background-repeat: no-repeat;
            background-position: left center;
            position: absolute;
            right: 0;
            top: 15px;
            padding-left: 20px;
            text-transform: none;
            font-weight: bold;
            cursor: pointer;
          }
        }

        .v-input:not(.v-input--radio-group) .v-input__slot {
          border: none;
          border-bottom: 2px solid rgba(0, 0, 0, 0.14);
          border-radius: 0;
          padding-left: 0;
        }

        label {
          text-transform: capitalize;
        }
        .v-input__prepend-inner {
          margin-top: 25px;
        }

        .v-input.upper input {
          text-transform: uppercase;
        }
      }

      .v-menu__content {
        position: fixed !important;
      }
      .v-select {
        label {
          text-transform: capitalize;
          top: 0px;
          padding-left: 0;
          font-size: 18px;
          /*display: none;*/
        }
      }
    }
  }
}
</style>
